module.exports = __webpack_public_path__ + "assets/img/sdwan-module6-2.3692e793.jpg";